import React from 'react'
import styles from './SplitLayout.module.scss'

type Ratio = '2-1' | '1-1' | '3-1'

interface SplitLayoutProps {
  children: React.ReactNode
  ratio?: Ratio
  className?: never
}

const ratioMap: Record<Ratio, string> = {
  '2-1': styles.ratio21, '1-1': styles.ratio11, '3-1': styles.ratio31,
}

export const SplitLayout: React.FC<SplitLayoutProps> = ({ children, ratio = '2-1' }) => (
  <div className={[styles.split, ratioMap[ratio]].join(' ')}>{children}</div>
)
